import React, { useEffect, useState } from "react";
import DatePopUp from "./date_popup.js";
import "../styles/history_popup.css";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const AcceptHearings = (props) => {
  const [hearings, setHearings] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [dateId, setDateId] = useState("");
  const [loading, setLoading] = useState(true);

  const closeDatePopUp = (e) => {
    setShowDate(!showDate);
    setDateId("");
    getData();
  };

  const showDatePopUp = (e) => {
    e.preventDefault();
    var value = e.currentTarget.attributes.value.value;
    setDateId(value);
    showDateP();
  };

  const showDateP = () => {
    setShowDate(true);
  };

  const fetchHearings = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsToAccept", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        var hearingsArr = data.filter(
          (el) => new Date(el.date) >= new Date("2023-01-01")
        );
        hearingsArr = hearingsArr.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        });
        setHearings(getAllowedClients(hearingsArr));
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getAllowedClients = (data) => {
    if (props.user.allowedClients === "all") {
      return data;
    } else {
      var allowed = props.user.allowedClients
        .toString()
        .replaceAll(" ", "")
        .split(",");
      var arr = [];
      allowed.map((el) => {
        arr = arr.concat(data.filter((el2) => +el2.clientId === +el));
      });
      return arr;
    }
  };

  const getData = () => {
    setLoading(true);
    fetchHearings();
  };

  useEffect(() => {
    getData();
  }, []);

  const destopData = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="hearingTitle">
          AKCEPTUJ TERMINY ROZPRAW ({hearings.length} rekordów)
        </div>
        <table style={{ marginTop: "5vh" }} className="clients_table">
          <tr key={0}>
            <th>Data rozprawy</th>
            <th>Klient</th>
            <th>Temat</th>
          </tr>
          {hearings.map((el) => (
            <>
              <tr id={""} key={el.identifier}>
                <td value={el.id} onClick={showDatePopUp}>
                  {el.date}
                </td>
                <td value={el.id} onClick={showDatePopUp}>
                  {el.name}
                </td>
                <td value={el.id} onClick={showDatePopUp}>
                  {el.subject}
                </td>
              </tr>
            </>
          ))}
        </table>
      </>
    </>
  );

  const mobileData = (
    <>
      <>
        <div className="closeBox">
          <button className="closeClientButton" onClick={props.close}>
            X
          </button>
        </div>
        <div className="hearingTitle">
          AKCEPTUJ TERMINY ROZPRAW ({hearings.length} rekordów)
        </div>
        <table style={{ marginTop: "5vh" }} className="clients_table">
          <tr key={0}>
            <th>Data rozprawy</th>
            <th>Klient</th>
            <th>Temat</th>
          </tr>
          {hearings.map((el) => (
            <>
              <tr id={""} key={el.identifier}>
                <td value={el.id} onClick={showDatePopUp}>
                  {el.date}
                </td>
                <td value={el.id} onClick={showDatePopUp}>
                  {el.name}
                </td>
                <td value={el.id} onClick={showDatePopUp}>
                  {el.subject}
                </td>
              </tr>
            </>
          ))}
        </table>
      </>
    </>
  );

  return (
    <>
      {showDate ? (
        <>
          <DatePopUp
            dateID={dateId}
            hearingsData={props.hearingsData}
            hearingsSheetData={props.hearingsSheetData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            close={closeDatePopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            substitutesData={props.substitutesData}
            history={true}
            checkPermissions={props.checkPermissions}
            team={props.team}
            tasksTeam2Data={props.tasksTeam2Data}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archDateTeam2={props.hearingsArchTeam2SheetData}
            logClientAction={props.logClientAction}
          />
        </>
      ) : (
        ""
      )}
      {showDate ? (
        ""
      ) : (
        <div className="mainContainerDatePopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="desktopFilters">{destopData}</div>
              <div className="mobileFilters">{mobileData}</div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default AcceptHearings;
